import React, { useMemo } from "react";
import HospitalIcon from "../img/hospital.png";
import bedIcon from "../img/bed.png";
import bimarkIcon from "../img/bimar.png";
import ctScanIcon from "../img/ct-scan.png";
import "../css/section-one.scss";
import InfoCard from "./info-card";

export const SectionOne = ({ hospitalInfo, wardList, strategicGoals }) => {
  const wardsGroup = useMemo(() => {
    let wards = {
      darmani: [],
      parakilinik: [],
      edari: [],
      kilinik: [],
    };

    if (wardList && wardList.length) {
      wardList.forEach((ward) => {
        if (ward.section === "درمانی") {
          wards.darmani = ward.wards;
        }
        if (ward.section === "پاراکلینیک") {
          wards.parakilinik = ward.wards;
        }
        if (ward.section === "اداری و پشتیبانی") {
          wards.edari = ward.wards;
        }
        if (ward.section === "کلینیک") {
          wards.kilinik = ward.wards;
        }
      });
    }

    return wards;
  }, [wardList]);

  return (
    <div className="section_1">
      <div className="hospital_wards">
        <p className="title iran-sans_Bold">بخش هـای {hospitalInfo?.name}</p>
        <div className="hospital_box_container">
          <div className="hospital_box">
            <div className="hospital_box_header">
              <img className="hospital_box_icon" src={bedIcon} alt="" />
              <span className="subtitle iran-sans_Bold">درمانـی</span>
              <div className="number">
                <span className="iran-sans_Bold">
                  {wardsGroup?.darmani?.length || 0}
                </span>
              </div>
            </div>
            <div className="hospital_box_body">
              <ul>
                {wardsGroup?.darmani?.map((w) => (
                  <li
                    className="hospital_box_body_item iran-sans_Bold"
                    key={w.id}
                  >
                    {w.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="hospital_box">
            <div className="hospital_box_header">
              <img className="hospital_box_icon" src={HospitalIcon} alt="" />
              <span className="subtitle iran-sans_Bold">اداری و پشتیبانـی</span>
              <div className="number">
                <span className="iran-sans_Bold">
                  {wardsGroup?.edari?.length || 0}
                </span>
              </div>
            </div>
            <div className="hospital_box_body">
              <ul>
                {wardsGroup?.edari?.map((w) => (
                  <li
                    className="hospital_box_body_item iran-sans_Bold"
                    key={w.id}
                  >
                    {w.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="hospital_box">
            <div className="hospital_box_header">
              <img className="hospital_box_icon" src={ctScanIcon} alt="" />
              <span className="subtitle iran-sans_Bold">پاراکلینیـک</span>
              <div className="number">
                <span className="iran-sans_Bold">
                  {wardsGroup?.parakilinik?.length || 0}
                </span>
              </div>
            </div>
            <div className="hospital_box_body">
              <ul>
                {wardsGroup?.parakilinik?.map((w) => (
                  <li
                    className="hospital_box_body_item iran-sans_Bold"
                    key={w.id}
                  >
                    {w.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="hospital_box">
            <div className="hospital_box_header">
              <img className="hospital_box_icon" src={bimarkIcon} alt="" />
              <span className="subtitle iran-sans_Bold">کلینیـک</span>
              <div className="number">
                <span className="iran-sans_Bold">
                  {wardsGroup?.kilinik?.length || 0}
                </span>
              </div>
            </div>
            <div className="hospital_box_body">
              <ul>
                {wardsGroup?.kilinik?.map((w) => (
                  <li
                    className="hospital_box_body_item iran-sans_Bold"
                    key={w.id}
                  >
                    {w.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="hospital_strategic_statements">
        <p className="title iran-sans_Bold">
          بیانیـه هـای استـراتژیک بیمـارستـان
        </p>
        <button
          className="see_strategic_statements_btn iran-sans_Bold"
          onClick={() =>
            window.open(
              "https://snjob.ir/management/#/improve_quality/programs?to_strategy=true",
              "_blank"
            )
          }
        >
          مشـاهـده جزییـات سنـد استراتـژیک
        </button>
      </div>
      <InfoCard title="سیـاست هـای کلان" className="macro_policies_card">
        <ul className="ul_list mt-3">
          <li className="ul_list_item">توسعـه و چابک سـازی منابـع انسانـی</li>
          <li className="ul_list_item">
            توسعـه منابـع فیزیکـی(نوسـازی و بهینـه سـازی فضـای فیزیکـی، تاسیسـات
            و تجهیـزات و امکانـات)
          </li>
          <li className="ul_list_item">
            انتظـام و شفـاف سـازی مالـی با اولویت اقتصـاد سلامت
          </li>
        </ul>
      </InfoCard>
      <InfoCard title="اهداف استراتـژیک" className="strategic_goals">
        <ul className="ul_list mt-3">
          {strategicGoals?.map((item, index) => (
            <li className="ul_list_item" key={index}>
              {item}
            </li>
          ))}
        </ul>
      </InfoCard>
    </div>
  );
};
